import { NavLink } from 'react-router-dom';

const AdminSidebar = () => {
  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊' },
    { path: '/admin/profile', label: 'Profile', icon: '👤' },
    { path: '/admin/projects', label: 'Projects', icon: '💼' },
    { path: '/admin/skills', label: 'Skills', icon: '🛠️' },
    { path: '/admin/sections', label: 'Sections', icon: '📋' },
    { path: '/admin/experience', label: 'Experience', icon: '📝' },
    { path: '/admin/testimonials', label: 'Testimonials', icon: '💬' },
  ];

  return (
    <aside className="fixed left-0 top-16 bottom-0 w-64 bg-slate-800 border-r border-slate-700 overflow-y-auto">
      <nav className="py-6">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/admin'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-6 py-3 text-slate-300 hover:bg-slate-700 transition-colors ${
                isActive ? 'bg-slate-700 border-l-4 border-violet-500' : ''
              }`
            }
          >
            <span className="text-xl">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;

